import { render, staticRenderFns } from "./ProvisionPackage.vue?vue&type=template&id=51175aac&scoped=true"
import script from "./ProvisionPackage.vue?vue&type=script&lang=js"
export * from "./ProvisionPackage.vue?vue&type=script&lang=js"
import style0 from "./ProvisionPackage.vue?vue&type=style&index=0&id=51175aac&prod&lang=scss"
import style1 from "./ProvisionPackage.vue?vue&type=style&index=1&id=51175aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51175aac",
  null
  
)

export default component.exports